/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Rendering_Event_AudioInputs */



/**
* | output |
* | --- |
* | "Rendering Event Audio" |
*
* @param {Audio_Description_Export_Status_Rendering_Event_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_rendering_event_audio = /** @type {((inputs?: Audio_Description_Export_Status_Rendering_Event_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Rendering_Event_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rendu audio des événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiowiedergabe bei Ereignissen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Audio dell'evento di rendering")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рендеринг аудиособытий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Representación de audio de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("渲染事件音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントオーディオのレンダリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रेंडरिंग इवेंट ऑडियो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renderização de áudio de evento")
	return /** @type {LocalizedString} */ ("Rendering Event Audio")
});